export type ComponentMountable = {
  /**
 *
 *
 *
 *
 *
 */
  readonly mounted: boolean | undefined;

  /*                                */
  __$$: "Mountable Component Marker";
};

export const setMountState = <E extends HTMLElement & ComponentMountable>(
  component: E,
  state: boolean,
): void => {
  /*                                                                                          */
  (component as { mounted?: boolean }).mounted = state;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const waitForMount = <E extends (HTMLElement & ComponentMountable) | null | undefined>(
  component: E,
  options?: AddEventListenerOptions,
): Promise<E> =>
  new Promise((resolve) => {
    if (!component || component.mounted) return resolve(component);

    const opts = { ...options, once: true };
    component.addEventListener("oc-mount", () => resolve(component), opts);
  });
